import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import {
	Ribbon as BaseRibbon,
	RibbonIcon,
	RibbonLabel,
	type RibbonProps,
} from "@commerce-frontend/ui/base/Ribbon/Ribbon";

type Props = {
	label: string;
} & RibbonProps;

export const Ribbon = ({ label, color, ...props }: Props) => {
	return (
		<BaseRibbon color={color} {...props}>
			{color === "yellow" ? (
				<RibbonIcon>
					<Icon icon="arrow-down-right" className="size-3 bg-black" />
				</RibbonIcon>
			) : null}
			<RibbonLabel>{label}</RibbonLabel>
		</BaseRibbon>
	);
};
